const SectionTitle = ({ normalText, coloredText }) => {
  return (
    <h2 className="h2 leading-tight font-bold">
      {normalText} <span className="text-accent">{coloredText}</span>
    </h2>
  );
};
export default SectionTitle;
